import { PureComponent } from 'react';
import { connect } from 'unistore/react';
import io from 'socket.io-client';

import { hasOwn } from '@utils/customLib';
import { getCoinProperty } from '@utils/params';
import {
	actionsCombiner,
	balanceActions,
	dashboardActions,
	coinsActions,
	tickerActions,
} from '@utils/store/actions';

export default connect(
	'tabInFocus, focusOutTime, currentTradingCoin, newTrades',
	actionsCombiner(
		balanceActions,
		dashboardActions,
		coinsActions,
		tickerActions
	)
)(
	class BbControlRoom extends PureComponent {
		static getDerivedStateFromProps(nextProps, { tradeCoin }) {
			const { __setCurrentTradingCoin, coin, shownMarket } = nextProps;

			if (coin !== tradeCoin) {
				__setCurrentTradingCoin(
					`${coin}${shownMarket === 1 ? '-usdt' : ''}`
				);

				return {
					tradeCoin: coin,
				};
			}

			return {};
		}

		constructor(props) {
			super(props);

			this.state = {
				tradeCoin: null,
			};
			this.tradeLinkPath = null;
			this.ioSocket = null;
		}

		componentDidMount() {
			this.closeNReconnectWS();
			this.checkNewCoins();
		}

		componentDidUpdate(prevProps) {
			const {
				tabInFocus,
				currentTradingCoin: { coin, market_id },
				__fetchingTradeOrders,
				// __checkBalances,
				__resetTradeLists,
			} = this.props;

			if (
				prevProps.currentTradingCoin.market_id !== market_id ||
				prevProps.currentTradingCoin.coin !== coin
			) {
				__fetchingTradeOrders();
				if (prevProps.currentTradingCoin.market_id === market_id) {
					this.switchWS();
				} else {
					__resetTradeLists();
					this.closeNReconnectWS();
				}

				this.checkNewCoins();
			}

			if (tabInFocus !== prevProps.tabInFocus) {
				this.connectOnFocus(tabInFocus);
			}
		}

		componentWillUnmount() {
			this.killWS();
			const {
				__resetTradeOrders,
				__resetTradeLists,
				__resetTradeHistory,
			} = this.props;

			__resetTradeOrders();
			__resetTradeLists();
			__resetTradeHistory();
		}

		connectOnFocus = tabInFocus => {
			tabInFocus
				? this.enableBehindTheScenes()
				: this.disableBehindTheScenes();
		};

		enableBehindTheScenes = () => {
			clearTimeout(this.updateRateCutOff);
			if (
				Date.now() - this.props.focusOutTime > 60000 ||
				!this.ioSocket
			) {
				this.closeNReconnectWS();
			}
		};

		disableBehindTheScenes = () => {
			this.updateRateCutOff = setTimeout(() => {
				this.killWS();
			}, 60000);
		};

		checkNewCoins = () => {
			const { newTrades, __setNewTrade } = this.props;
			const lowerCoin = this.state.tradeCoin.toLowerCase();

			if (newTrades.indexOf(lowerCoin) > -1) {
				__setNewTrade(lowerCoin);
			}
		};

		initWebSocket = () => {
			const {
				currentTradingCoin: { coin: currCoin },
			} = this.props;
			this.ioSocket = io('https://socket.bitbns.com', {
				transports: ['websocket'],
				path: this.tradeLinkPath,
				// query: {
				// 	withTicker: true,
				// },
			});
			const socketCoin =
				getCoinProperty(currCoin, 'tradeSocket') || currCoin;
			const coinUpper = socketCoin.toUpperCase();

			this.ioSocket.emit('switchRoom', `news_${coinUpper}`);
			this.ioSocket.on('connect_error', error => {
				console.log('connect_error', error);
			});
			this.ioSocket.on('disconnect', error => {
				if (
					error === 'transport error' &&
					this.tradeLinkPath.indexOf(currCoin.toUpperCase()) === -1
				) {
					this.killWS();
					setTimeout(this.closeNReconnectWS, 300);
				}
			});

			this.ioSocket.on('news', news => {
				const {
					currentTradingCoin: { coin, market_id },
					__fillDoneList,
					__updateCurrentCoinRate,
				} = this.props;

				if (typeof news === 'string' && news.includes('type')) {
					try {
						const msg = JSON.parse(news);

						if (msg && hasOwn(msg, 'type')) {
							if (
								msg.type === 'tradeList' &&
								msg.data.length > 0
							) {
								const { data } = msg;
								const currRate = data[0].rate;

								__fillDoneList(data);

								if (data.length > 0 && !!currRate) {
									__updateCurrentCoinRate(
										coin,
										currRate,
										market_id
									);
								}
							}
						}
					} catch (err) {
						console.log('trades:', err);
					}
				}
			});
		};

		killWS = () => {
			if (this.ioSocket) {
				this.ioSocket.close();
				this.ioSocket = null;
			}
		};

		switchWS = () => {
			const {
				currentTradingCoin: { coin },
				__resetTradeLists,
			} = this.props;
			const socketCoin = getCoinProperty(coin, 'tradeSocket') || coin;
			const coinUpper = socketCoin.toUpperCase();

			__resetTradeLists();
			if (this.ioSocket) {
				this.ioSocket.emit('switchRoom', `news_${coinUpper}`);
			} else {
				this.closeNReconnectWS();
			}
		};

		closeNReconnectWS = () => {
			const {
				currentTradingCoin: { market_id },
			} = this.props;

			if (this.ioSocket) {
				this.ioSocket.close();
			}
			if (market_id === 1) {
				this.tradeLinkPath = '/bnsUSDTMSocket/';
			} else {
				this.tradeLinkPath = '/bnsINRMSocket/';
			}

			this.initWebSocket();
		};

		render() {
			return null;
		}
	}
);
